import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  Timestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';

// Interactive Learning Content Service
export const interactiveLearningService = {
  // Get interactive learning content for a topic
  async getTopicContent(courseId, topicName) {
    try {
      const contentRef = doc(db, 'courses', courseId, 'interactiveLearning', topicName);
      const contentDoc = await getDoc(contentRef);
      
      if (contentDoc.exists()) {
        return contentDoc.data();
      }
      return null;
    } catch (error) {
      // If permission denied and document doesn't exist, return null (no content yet)
      if (error.code === 'permission-denied' || error.code === 'missing-or-insufficient-permissions') {
        console.debug('No content found or permission issue for topic:', topicName);
        return null;
      }
      console.error('Error getting topic content:', error);
      throw error;
    }
  },

  // Save interactive learning content for a topic
  async saveTopicContent(courseId, topicName, content) {
    try {
      const contentRef = doc(db, 'courses', courseId, 'interactiveLearning', topicName);
      
      // Check if document exists
      const contentDoc = await getDoc(contentRef);
      
      const contentData = {
        courseId,
        topicName,
        // Support both old single coding format and new array format
        coding: content.coding || null,
        codingExamples: content.codingExamples || null,
        updatedAt: Timestamp.now()
      };

      if (contentDoc.exists()) {
        // Update existing document
        await updateDoc(contentRef, contentData);
      } else {
        // Create new document
        await setDoc(contentRef, {
          ...contentData,
          createdAt: Timestamp.now()
        });
      }
    } catch (error) {
      console.error('Error saving topic content:', error);
      throw error;
    }
  },

  // Delete interactive learning content for a topic
  async deleteTopicContent(courseId, topicName) {
    try {
      const contentRef = doc(db, 'courses', courseId, 'interactiveLearning', topicName);
      await deleteDoc(contentRef);
    } catch (error) {
      console.error('Error deleting topic content:', error);
      throw error;
    }
  }
};

